<template>
  <div id="browse">
    <Navi currentPage="2-2"></Navi>
    <div class="body_container main_context">
      <div class="breadcrumb_con">
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Analyze</el-breadcrumb-item>
          <el-breadcrumb-item>EMIC: causal genes inference</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <AnalyzeEMIC></AnalyzeEMIC>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import AnalyzeEMIC from '@/components/analyze_emic.vue'
export default {
    name: 'browse',
    components: {Navi,Footer,AnalyzeEMIC},
    data:function(){
        return {
            show_pheno:true,
            show_cell:false,
            show_gene:false,
            sonmanu:[{
                name:'Browse/Search by Phenotype',
                id:1,
                class:'selected_li'
                },
                {
                name:'Browse/Search by Cell',
                id:2,
                class:'unselected_li'
                },
                {
                name:'Search by Gene',
                id:3,
                class:'unselected_li'
                }
            ],

            paras:{
                has_outline:true, 
                msg:{
                    'Get Start':[
                        'Single-cell cluster and phenotypes cross annotation framework\
                        ,(SPA) is ...',
                        'The framework contains 20,000 cell clusters and ~1,000 GWAS\
                        summary statistics ...'
                    ],
                    'Results':{
                        'Relevant cell types':[
                            'SPA allows user to infer the relevant cells ...',
                            'For example, we have inferred the geneticlly relevant cell\
                            types of the COVID-19 is T cells.'
                        ]
                    }
                }
            }
        }
    },
    methods:{
        show_box(it){
            this.sonmanu.forEach((item,index)=>{
                item.class='unselected_li'
            })
            var id=it.id
            it.class='selected_li'
            console.log(id)
            this.show_cell=false
            this.show_pheno=false
            this.show_gene=false
            if(id==1){
                this.show_pheno=true
            }if(id==2){
                this.show_cell=true
            }if(id==3){
                this.show_gene=true
            }
        }
    }
}
</script>



<style scoped>


.son_frame{
    width: 1200px; 
    margin: 0 auto; 
    border: solid #428bca;
    /* border: solid #E1EAEA ; */
    box-sizing: border-box;
    margin-bottom: 50px;
}

ul {
  margin: 0;
  height: 40px;
  list-style: none;
  margin-top: 50px;
  margin-left: 0;
  padding-inline-start:0;
}
li {
    background: #428bca;
    vertical-align: middle;
    height: 40px;
    line-height:40px;
    float: left;
    padding-left: 20px;
    padding-right: 20px;
    border: solid #428bca;
    border-bottom: none;
    margin-left: 0;
}
li:hover {
    cursor:pointer;
}

.selected_li {
    background: #FFFFFF;
    float:left;
    color:  #428bca;
}

.unselected_li {
    background: #428bca;
    float:left;
    color: #FFFFFF;
}

</style>


// WEBPACK FOOTER //
// src/views/emic.vue